import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

const initial = {
  items: []
}

const getActions = generateActions('faq/list/GET')

export const getList = createAction(
  API_CONST,
  () => ({
    actions: getActions,
    url: 'faq'
  })
)

export default handleActions({
  [getActions[0]]: () => ({ ...initial }),
  [getActions[1]]: (state, { payload }) => ({ ...state, items: [ ...state.items, ...payload ] }),
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/about/index.js